import Header from '../../../__Layout/Header';
import React , {useState} from "react";
import Loader from '../../../utils/Loader';
import { useGetStudentResourceQuery} from "../../../Services/api";
import {pageUrl} from "../../../utils/constants/constants";
export default function Index() {
    const [unit, setUnit] = useState(0);
    const [unitName, setUnitName] = useState("");    
    const { 
        data: StudentResource,
        isLoading: isGetLoading,
    } = useGetStudentResourceQuery({ pageUrl, params:  {unit}  });
  
      
      const findCourse=(e)=>{
        setUnit(e.target.value);
        setUnitName(e.target.selectedOptions[0].getAttribute('data-myattribute'));
      }
      if(isGetLoading ) return  <Loader></Loader>
    return (
        <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Resources</h5>
                    <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                       <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">Resources</button>
                        </li>
                    </ul>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body table-responsive">
                                                
                                                <div className='row mb-4'>
                                                    <div className='col-lg-2'></div>
                                                    <div className='col-lg-8 bg-dark'>
                                                        <p className='text-center text-white'>Course Name</p>
                                                       <h2 className='text-center text-white'>
                                                           {unitName}
                                                        </h2>
                                                    </div>
                                                    <div className='col-lg-2'></div>
                                                </div>
                                                <div className='row mb-3'>
                                                    <div className='col-lg-12'>
                                                    <select className="form-control" onChange={findCourse}>
                                                        <option value="">Select Course</option>                                           
                                                        {                            
                                                        StudentResource?.course !== 'undefined' ? StudentResource?.course?.map((item) => {
                                                            return (
                                                                    <option key={item?.enroll_id} value={item?.course?.course_id}  data-myattribute={item?.course?.course_name} >
                                                                      {item?.course?.course_name}
                                                                    </option>                                           
                                                                )
                                                            })
                                                            :
                                                            '<option value="">Select Course</option>'
                                                        }
                                                    </select>
                                                    </div>
                                                </div>
                       
                                                <table className="table">
                                                        <thead>
                                                            <tr>
                                                                {/* <th className='text-capitalize'>#</th> */}
                                                                <th className='text-capitalize'>Resources</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            StudentResource?.data?.map((item) => {
                                                            return (
                                                                <tr key={item.rid}>
                                                                  {/* <td>{item.rid}</td> */}
                                                                  <td className='text-uppercase'>
                                                                    <a href={item?.resources_link} target="_blank">{item?.resources_name}</a></td>
                                                                </tr>                                            
                                                                )  
                                                            })  
                                                        } 
                                                        </tbody>
                                                </table>                        
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>  
                        </div>
                    </div>
                </div>
            </div>
            </main>
           
        </div>
    );
}
